import { Suspense, lazy, useState, useEffect } from 'react';

const SectorMarketingLanding = lazy(() => import('./SectorMarketingLanding'));

interface SectorMarketingRouteProps {
  path: string;
  onNavigate: (path: string) => void;
}

function SectorLoading() {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center', background: '#07131d' }}>
      <div style={{ width: 40, height: 40, border: '2px solid rgba(103,232,249,0.2)', borderTopColor: '#67e8f9', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
      <style>{`@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}

export default function SectorMarketingRoute({ path, onNavigate }: SectorMarketingRouteProps) {
  const [config, setConfig] = useState<any>(null);

  useEffect(() => {
    // Dynamically import the 401KB data file only when this route mounts
    import('./SectorMarketingData').then(({ getSectorConfig, SECTOR_MARKETING_DATA }) => {
      setConfig(getSectorConfig(path) ?? SECTOR_MARKETING_DATA[0]);
    });
  }, [path]);

  if (!config) return <SectorLoading />;

  return (
    <Suspense fallback={<SectorLoading />}>
      <SectorMarketingLanding
        config={config}
        onAuthSuccess={() => onNavigate('/console')}
        onNavigate={onNavigate}
      />
    </Suspense>
  );
}
